import React from "react";

import { SolutionsFrame } from "components/solutions/SolutionsFrame";
import { BlockStandard } from "components/admin/BlockStandard";
import { Card, CardMedia, CardContent, Typography, Grid } from "@mui/material";

const FRAME_DATA = {
    title: "Monitorar meu sistema solar",
    buttonText: "Ir para a loja virtual",
}

export const AutomateProsumerEnd = ({ history }) => {
    const handleClick = () => { history.push("/frames/store") }

    return (
        <SolutionsFrame {...FRAME_DATA} onButtonClick={handleClick}>
            <BlockStandard hideDivider>
                <Typography variant="h2">
                    Obrigado pelo envio!
                </Typography>
                <Typography variant="h2">
                    Em até dois dias úteis seus dados estarão disponíveis aqui no App Enermatch!
                </Typography>
                <Typography>
                    Enquanto isso, comece a poupar com os dispositivos IoT que garantem que os ar-condicionados funcionem somente quando necessário e medidores inteligentes que acompanham seu consumo em tempo real te ajudando a evitar o desperdício de energia.
                </Typography>
            </BlockStandard>

            <BlockStandard hideDivider>
                <Grid item container direction="row" gap={2}>
                    <Card sx={{ flex: 1, flexDirection: "column "}}>
                        <CardMedia sx={{ flex: 1, height: 200 }} image="https://www.enermatch.com/wp-content/uploads/2024/11/foto-principal-smartmeter.jpg" />
                        <CardContent sx={{ flex: 1 }}>
                            <Typography variant="body2">
                                Medidor Inteligente Wi-Fi com TCs
                            </Typography>
                            <Typography>A partir de:</Typography>
                            <Typography variant="body2">R$ 149,00</Typography>
                        </CardContent>
                    </Card>
                    <Card sx={{ flex: 1}}>
                        <CardMedia sx={{ flex: 1, height: 200 }} image="https://www.enermatch.com/wp-content/uploads/2024/11/infra-vermelho-01.jpg" />
                        <CardContent sx={{ flex: 1 }}>
                            <Typography variant="body2">
                                Controle Remoto Inteligente Un. Infra
                            </Typography>
                            <Typography>A partir de:</Typography>
                            <Typography variant="body2">R$ 149,00</Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </BlockStandard>
        </SolutionsFrame>
    )
}
